import { h, Host } from "@stencil/core";
/**
 * @slot (default) - The panel content
 */
export class PopoverPanel {
    constructor() {
        this.placement = null;
        this.arrow = true;
        this.variant = "default";
    }
    render() {
        return (h(Host, { key: 'dac1cc3c167ce44b59e5dd996dde285d0b19533e', class: {
                [`ux-popover-panel`]: true,
                [`ux-popover-panel--${this.variant}`]: this.variant && this.variant !== "default",
                [`ux-popover-panel--arrow`]: this.arrow && this.placement !== null
            }, "data-popover-placement": this.placement }, this.arrow && h("ux-popover-panel-arrow", { key: '15eb65547436f34b4bf38bb71085664781c8baf3' }), h("div", { key: 'acfe173fc8fa67aaa2ae1891fedd8394c0b23cf0', class: "ux-popover-panel__inner" }, h("slot", { key: '564dcdc341d8b027638a4432772111ec5c1f5f1e' }))));
    }
    static get is() { return "ux-popover-panel"; }
    static get originalStyleUrls() {
        return {
            "$": ["./popover-panel.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["popover-panel.css"]
        };
    }
    static get properties() {
        return {
            "placement": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "PopoverPlacementType | null",
                    "resolved": "\"bottom\" | \"bottom-end\" | \"bottom-start\" | \"center\" | \"left\" | \"left-end\" | \"left-start\" | \"right\" | \"right-end\" | \"right-start\" | \"top\" | \"top-end\" | \"top-start\" | null",
                    "references": {
                        "PopoverPlacementType": {
                            "location": "import",
                            "path": "../popover/interface",
                            "id": "src/components/popover/interface.ts::PopoverPlacementType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Placement of the popover relative to the target element"
                },
                "attribute": "placement",
                "reflect": false,
                "defaultValue": "null"
            },
            "arrow": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether or not to display an arrow"
                },
                "attribute": "arrow",
                "reflect": false,
                "defaultValue": "true"
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"default\" | \"primary\" | \"secondary\"",
                    "resolved": "\"default\" | \"primary\" | \"secondary\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Style variant of the panel"
                },
                "attribute": "variant",
                "reflect": false,
                "defaultValue": "\"default\""
            }
        };
    }
}
//# sourceMappingURL=popover-panel.js.map
